




















import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    currentCommentIndex: {
      type: Number,
      default: 0,
    },
    totalCommentsCount: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const text = computed(() =>
      t('cc_number_of_total_comments', {
        number: props.currentCommentIndex + 1,
        total: props.totalCommentsCount,
      })
    );

    const previousDisabled = computed(() => props.currentCommentIndex === 0);
    const nextDisabled = computed(() => props.currentCommentIndex === props.totalCommentsCount - 1);
    return {
      previousDisabled,
      nextDisabled,
      text,
    };
  },
});
